import React, {useEffect, useState} from "react";

import {Card, Chip} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";
import 'ckeditor5/ckeditor5.css';
import ManageTaskDefinition from "../inventory/ManageTaskDefinition";
import {archiveTask, getCompanyTasks} from "../common/api/TasksApi";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";

export default function AutomatedTasks({callback}) {
  const [manageTask, setManageTask] = useState(false);
  const [currentTask, setCurrentTask] = useState();
  const [tasks, setTasks] = useState();
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  const archiveTaskFn = (task) => {
    archiveTask(task).then(()=>{
      setSaving(false);
      setConfirmDelete(false);
      setConfirmation(null);
      initTasks();
    })
  }
  const manageTaskFn = (_task) => {
    if (_task) {
      setCurrentTask({..._task});
    } else {
      setCurrentTask(null)
    }
    setManageTask(true);
  }

  const confirmDeleteItem = (item) => {
    let confirmation = {
      title: 'Archive ' + item.taskName + '?',
      message: 'Confirm archive ' + item.taskName + '?',
      entity: item
    }
    setConfirmation(confirmation);
    setConfirmDelete(true);
  }

  const initTasks = () => {
    getCompanyTasks().then((resp)=>{
      setTasks(resp);
    });
  }

  useEffect(()=> {
    initTasks();
  }, [])

  const TaskActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'task-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageTaskFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteItem(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <>
      <Grid item xs={12}>
        <div id="smart-messages" style={{
          position: 'relative',
          left: '-999em',
          zIndex: '-999',
          top: '-100px'
        }}/>
        <Card>
          <MDBox p={3}>
            <h5>
              Smart Messages
              <MDButton
                color="secondary"
                size="small"
                className={'pull-right'}
                onClick={(e) => {
                  manageTaskFn();
                }}>
                <Icon>quickreply</Icon>&nbsp;Add Task
              </MDButton>
            </h5>
            <p className={'py-2 fw-light'}>
              Use automated tasks to automate reminders and follow-up communications. For example, you schedule send a
              Reminder email for an upcoming Event to send the day before the Event.
            </p>

            <ul className={'list-group'}>
              {tasks?.sort((a, b) => a.id > b.id ? 1 : -1).map((task, index) => {
                  return (
                    <li
                      className={'list-group-item'}
                      key={index}>
                      {task.id &&
                        <>
                           <span className="d-block pull-right">
                                    <TaskActions item={task}/>
                                  </span>
                          <a
                            href={'#'}
                            onClick={(e) => {
                              e.preventDefault();
                              manageTaskFn({...task});
                            }}>{task.taskName}</a>
                          <br/>

                          <MDTypography variant={"p"} fontWeight={"light"}>
                            Sends&nbsp;{task?.taskType?.name} named {task.communicationTemplate?.templateName}&nbsp;{task?.criteria}&nbsp;
                            {task.timeUnitType?.name}{task?.criteria>1 ? 's' : ''}&nbsp;
                            {task?.taskEventType?.id === 1 ? 'before' : 'after'} {task?.eventType.name} events
                          </MDTypography>
                          <br/>

                          <Chip label={task.communicationTemplate.templateName + ' Template'}
                                variant="outlined"
                                color="secondary"/>&nbsp;
                          <Chip label={task.taskEventType.name}
                                variant="outlined"
                                color="secondary"/>&nbsp;

                        </>

                      }
                    </li>
                  );
                })}
            </ul>

          </MDBox>
        </Card>
      </Grid>

      {confirmDelete && <Confirm confirmation={confirmation}
                                              show={confirmDelete}
                                              saving={saving}
                                              handleConfirm={()=>{
                                                setSaving(true)
                                                archiveTaskFn(confirmation?.entity)
                                              }}
                                              handleSave={()=>{
                                                setConfirmDelete(false);
                                                setConfirmation(null);
                                              }}/>}

      {manageTask && <ManageTaskDefinition taskDefinition={currentTask}
                                           show={manageTask}
                                           handleSave={() => {
                                              initTasks();
                                              setManageTask(false);
                                            }}
                                           handleClose={()=>{
                                             setManageTask(false)
                                           }} />
      }
    </>
  );
}